import { render, staticRenderFns } from "./DoseRecommendationTab.vue?vue&type=template&id=013f2322&scoped=true&"
import script from "./DoseRecommendationTab.vue?vue&type=script&lang=js&"
export * from "./DoseRecommendationTab.vue?vue&type=script&lang=js&"
import style0 from "./DoseRecommendationTab.vue?vue&type=style&index=0&id=013f2322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013f2322",
  null
  
)

export default component.exports